import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ConfigService } from '../commons/config.service';
import { SessionService } from '../commons/session.service';
import { ScrollService } from '../commons/scroll.service';
import { CartService } from '../commons/cart.service';
import { Param, ParamValue } from '../commons/models';
import { Router } from '@angular/router';

@Component({
  selector: 'config-control',
  template: require('./config-control.component.html'),
  // styles: [require('./config-control.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfigControlComponent implements OnInit {

  @Input()
  model: string;

  @Input()
  showHidden: boolean;

  @Input()
  param: Param;

  @Output('valueChange')
  valueChange: EventEmitter<any> = new EventEmitter();

  constructor(
    private config: ConfigService,
    private router: Router,
    private session: SessionService,
    public scroll: ScrollService,
    private cartService: CartService
  ) { }

  ngOnInit() {
    //console.log(this.param);
  }

  GoPersonalized(cmp, link) {
    this.router.navigate(['/' + link]);
  }


  setFormat(param, format, goNext: boolean) {

    if (this.EnableFormat(format)) {

      this.cartService.setFormat(format);

      this.onValueChange(param, format);
      // alert(goNext);
      if (goNext) {
        this.NextStep();
      }

    } else {
      let avviso = 'ATTENZIONE !\r\nImmagine troppo piccola per questo formato\r\nCaricare un immagine maggiormente risoluta';
      alert(avviso);

    }
  }

  NextStep() {
    let stringTable = 'Navbar' + this.router.url.split('/').reverse()[0];
    ////console.log('this.table: ' + stringTable);

    let thisSlideSort = 0;
    let thisButton = this.config.btnToggles.filter(r => r.isParameter && r.text === stringTable)[0];

    if (thisButton) {
      thisSlideSort = thisButton.sort;
      let NextUrl = this.config.btnToggles.filter(r => r.isParameter && r.sort > thisSlideSort)[0];
      if (NextUrl) {
        this.router.navigate(['/' + NextUrl.url]);
      }
    }
  }



  IsActiveFormat(format): string {
    return this.cartService.cart.currentCartProduct.format === format.split('|')[0] + '|' + format.split('|')[1] ? 'active' : '';
  }

  EnableFormat(value): boolean {
    if (value != null) {
      let isOK = false;

      let width = value.split('|')[2];
      let height = value.split('|')[3];

      if (!this.session.swapFormatSizes) {
        height = value.split('|')[2];
        width = value.split('|')[3];
      }

      if (
        (this.cartService.cart.currentCartProduct.naturalHeight > (height * this.config.RappRisoluzMin))
        &&
        (this.cartService.cart.currentCartProduct.naturalWidth > (width * this.config.RappRisoluzMin))
      ) {
        isOK = true;
      }
      return isOK;
    } else {
      return true;
    }
  }

  onValueChange(param, value) {
    //console.log('Changed: ' + param);
    this.valueChange.emit(value);
  }

  group(values: any[], size: number) {
    let ret = [];
    let groups = Math.floor(values.length / size);
    for (let i = 0; i < groups; i++) {
      ret.push({ values: values.slice(i * size, (i + 1) * size) });
    }
    if ((values.length % size) !== 0) {
      ret.push({ values: values.slice(groups * size) });
    }
    return ret;
  }

  isLabelLink(param: Param): boolean {
    return param.type === 'Label' || (param.type === 'Combo' && param.values.length <= 1);
  }

  getParamImage(paramName: string, value: string): string {
    if (value === 'NONE') {
      return `${this.config.imagesUrl}/param_ico/none.png`;
    } else {
      let extension = ".png";
      if (paramName == "SistemaFissaggio") {
        extension = ".jpg";
      }
      return `${this.config.imagesUrl}/param_ico/${paramName}/${value}${extension}`;
    }
  }

  getImage(param: Param, value: string): string {
    let name = `${param.name}_${value}`;
    return `${this.config.imagesUrl}/${this.model}/${this.config.imageMap[name] || name}.jpg`;
  }


  FormatsFiltered(items: ParamValue[], filtro: string): ParamValue[] {
    let arrayFiltrato = items.filter(item => item.value.indexOf(filtro) !== -1);
    return arrayFiltrato;
  }

  DistinctFormat(items: ParamValue[]): string[] {
    let uniqueNames: string[] = [];

    items.forEach(element => {
      let formatCateg: string = element.value.split('|')[0];
      if (uniqueNames.indexOf(formatCateg) === -1) { uniqueNames.push(formatCateg); }
    });

    return uniqueNames;
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/configurator/config-control.component.ts